export const TABLE_HEADERS = Object.freeze([
	'No.',
	'Mail config',
	'Requested',
	'To send',
	'Sent',
	'Delivered',
	'Opened',
	'Clicked',
	'Bounced',
	'Bought After Mail Sent',
	'Sell value',
	'Bought From Mail',
]);
